// src/app/job-description-model-popup/job-description-model-popup.component.ts
//Beautification Adding Double Quotes is Good Practice

import {Component, Input, ViewChild,ElementRef,HostListener,ViewChildren,QueryList,} from "@angular/core";
import { CommonModule } from "@angular/common";
import { WidgetInput } from "../Models/job-like-job.model";
import {StripHtmlPipe,SafeEmbedHtmlPipe,} from "../pipes/Angular-commonUtil.pipe";



@Component({
  selector: "job-description-model-popup",
  standalone: true,
  imports: [CommonModule, StripHtmlPipe, SafeEmbedHtmlPipe],
  templateUrl: "./job-description-model-popup.component.html",
  styleUrls: ["./job-description-model-popup.component.scss"],
})
export class JobDescriptionModelPOPUPComponent {
  @ViewChild("modalContent") modalContent!: ElementRef;
  @ViewChild("modalStart") closeButton!: ElementRef;
  @ViewChildren("accordionItem", { read: ElementRef })
  accordionItems!: QueryList<ElementRef>;
  @ViewChild("modalContainer") modalContainer!: ElementRef;
  @ViewChildren("accordionBody", { read: ElementRef }) accordionBodies!: QueryList<ElementRef>;

  pagetype: string = "";
  translateStrings: any = {};
  jobdescpritionAndTitle: {
    JobTitle: string;
    JobDescription: string;
    Clicked:number;
  }[] = [];
  expandedJobIndex: number | null = null;
  showModal: boolean = false;
  modalReady: boolean = false;
  @Input() set widgetData(data: WidgetInput) {
    this.translateStrings = data.TranslateStrings || {};
    this.jobdescpritionAndTitle = data.jobInformation || [];
    this.pagetype =data.pagetype;
    const hasValidJob = this.jobdescpritionAndTitle.some(
      (item) => item?.JobTitle && item?.JobDescription?.trim()
    );

    this.showModal = hasValidJob;
    if (hasValidJob) {
      setTimeout(() => {
        this.modalReady = true;
        if (this.closeButton) {
          this.closeButton.nativeElement.focus();
        }
      }, 0);
    }

    const index = this.jobdescpritionAndTitle.findIndex(
      (item) => item.Clicked === 1
    );
    if (index !== -1 && index < this.jobdescpritionAndTitle.length) {
      setTimeout(() => {
        this.toggleAccordion(index);
      }, 500); // Ensures DOM elements (like accordion bodies) are ready
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showModal || !this.modalReady) return;

    const clickedInside = this.modalContent?.nativeElement.contains(
      event.target
    );
    if (!clickedInside) {
      this.closeModal();
    }
  }

  @HostListener("document:keydown.escape", ["$event"])
  onEscapeKey(event: KeyboardEvent): void {
    this.closeModal();
  }
  toggleAccordion(index: number): void {
    if (this.expandedJobIndex === index) {
      this.expandedJobIndex = null;
    } else {
      this.expandedJobIndex = index;
      setTimeout(() => {
        const modalEl = this.modalContent?.nativeElement;
        const bodyEl = this.accordionBodies?.get(index)?.nativeElement;
        if (!bodyEl) {
          console.warn("Accordion body not found at index", index);
          return;
        }
        const modalRect = modalEl.getBoundingClientRect();
        const bodyRect = bodyEl.getBoundingClientRect();
        const offset = bodyRect.top - modalRect.top;
        if (modalEl && bodyEl) {
          const modalRect = modalEl.getBoundingClientRect();
          const bodyRect = bodyEl.getBoundingClientRect();
          const offset = bodyRect.top - modalRect.top;

          const targetScrollTop = modalEl.scrollTop + offset - 20;

          this.scrollToFast(modalEl, targetScrollTop, 200); // 200ms = fast and smooth
        }
      }, 300); // Increase delay to ensure rendering completes
    }
  }
  scrollToFast(
    container: HTMLElement,
    targetTop: number,
    duration: number = 300
  ) {
    const start = container.scrollTop;
    const change = targetTop - start;
    const startTime = performance.now();

    const animateScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      container.scrollTop = start + change * progress;

      if (elapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }

  jobdescriptionhandleKeydown(event: KeyboardEvent, index: number): void {
    this.toggleAccordion(index);
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
    }
  }

  closeModal(): void {
    this.showModal = false;
    this.modalReady = false;
  }
}
